import { FilterUserType } from "@reactive-resume/dto";
import { create } from "zustand";

type FilterAmbassadorState = {
  filterAmbassador: FilterUserType | null | undefined;
  setFilterAmbassador: (filter: FilterUserType) => void;
  replaceFilterAmbassador: (filter: FilterUserType | null) => void;
  resetFilterAmbassador: () => void;
};

export const userFilterAmbassadorStore = create<FilterAmbassadorState>((set) => ({
  filterAmbassador: null,
  setFilterAmbassador: (Nfilter) =>
    set((state) => ({
      filterAmbassador: {
        ...(state.filterAmbassador || {}),
        ...Nfilter,
      },
    })),

  replaceFilterAmbassador: (Nfilter) =>
    set((state) => ({
      filterAmbassador: {
        ...Nfilter,
      },
    })),

  resetFilterAmbassador: () => set((state) => ({ filterAmbassador: null })),
}));
